export enum ProjectMemberType {
    project = "project",
    trigger = "trigger",
    action = "action",
    webConfig = "webConfig",
    javaData = "javaData",
    triggerAction = "triggerAction",
    actionGroup = "actionGroup",
    triggerGroup = "triggerGroup",
    triggerActionGroup = "triggerActionGroup",
}
